import _cloneDeep from 'lodash/cloneDeep';

import * as types from './actionTypes';
import initialState from './initialState';

export default (state = _cloneDeep(initialState), action = {}) => {
  switch (action.type) {
    case types.GET_CONVERSATIONS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: action.payload.conversations,
        },
      };
    case types.GET_CONVERSATIONS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};
